/**
 * Base app object
 * @type {{init: Function}}
 */

//unused import (commented 28.04.18)
// import { media } from './components/media.js'
// import { ajax_form, Submit_transfer  }  from './components/ajax_form.js'
// import { Updating }  from './components/updating.js'

//used import
import { image } from './components/image.js'
import { item } from './components/item.js'
import { AjaxForm }  from './components/ajax_form.js'
import { ui } from './components/ui_components.js'
import { Datatime_picker } from './components/data_range.js'
import { fields } from './components/requests.js'
import { sortable } from './components/sortable.js'
import { getToken } from '../libs/getToken';
import { getLocale } from './components/locale';
import { Graphic } from './components/graphics';
import { dataTables } from './components/data_tables.js';
import { select } from './components/select.js'
import { DropZone } from "./components/dropzone";
import { Uploader } from "./components/uploader";
import { AjaxBlk } from "./components/ajax_blk";
import { SendAjaxFromEl } from "./components/ajax_el";

import { SwitcheryCustom } from "./components/switchery";

import '../../node_modules/bootstrap/dist/js/bootstrap'


$(document).ready(function() {
    global.app = new App();
    global.app.init();
});

class App {
    constructor(){
        let localeSettings = getLocale();
        this.locale = localeSettings.locale ;
        this.csrf_token = getToken();
    }

    init() {

        //checkbox switchery init
        // ui.switchery($('.js-switch'));

        /*//iCheck for checkbox and radio inputs
        ui.iCheckInit();*/


        //init Color picker
        ui.color_picker('.js-color-pick');

        //
        item.create_btn_init('.js_create');
        item.delete_btn_init('.js_delete');

        //init data tables
        dataTables.init('.js_data_table');

        //init image uploading
        image.uploadPreview('.js_image-preview');


        // Sortable init, for now bower can't load library, and i commented it
        sortable.init('.js-sortable');

        //Init multi fields
        fields.init({
            src: '.js-src',
            dest: '.js-copy-dest',
            item: '.js-copy-item',
            add_btn:  '.js-add',
            remove_btn: '.js-remove'
        });

        //init all graphics
        this.initAllGraphics();
        //Init dropzone
        this.dropzoneInit();
        //Init uploader
        this.uploaderInit();


        // Init Custom Swithery
        $('.js_switchery').each(function (i, el) {
            let switchery = new SwitcheryCustom(el);

            switchery.init();
        });



        /**
         * Initialize ajax sending form
         */

        let pagination = new SendAjaxFromEl('.js_btn-pagination', 'click', this.initPluginsInWrapper);
        pagination.onInit();

        let sendAjaxByClick = new SendAjaxFromEl('.js_ajax-by-click-btn', 'click', this.initPluginsInWrapper);
        sendAjaxByClick.onInit();

        let sendAjaxByChange = new SendAjaxFromEl('.js_ajax-by-change', 'change', this.initPluginsInWrapper);
        sendAjaxByChange.onInit();

        let sendFormByClickEl = new SendAjaxFromEl('.js_submit-form-by-click-el', 'click', this.initPluginsInWrapper, true);
        sendFormByClickEl.onInit();
        let sendFormByChangeEl = new SendAjaxFromEl('.js_submit-form-by-change-el', 'change', this.initPluginsInWrapper, true);
        sendFormByChangeEl.onInit();

        /**
         * Initialize sending ajax request with data from block (without form)
         */
        let submitDateFromBlk = new AjaxBlk('.js_ajax_blk-blk-submit', '.js_ajax_blk-btn-submit');
        submitDateFromBlk.init();

        this.initPluginsInWrapper();

        //unused initialization (commented 28.04.18)
        // ui.dependent_selects_init();
        // ui.box_collapse();
        // media.select('.js-media-select');
        // media.uploadPreview('.js-input-preview');
        // media.checkAllBtnInit('.js-media-checkAll');
        // let submit_transfer1 = new Submit_transfer('.js-send-click', '.js-send-change');
        // // Function auto-updating
        // $.each($('.js-update'), function(i, el){
        //     new Updating(el);
        // });
    }


    initPluginsInWrapper(wrapper = ''){
        console.log('init plugin  ' + wrapper)
      //init all selects
      select.initDefaultSelect(wrapper + ' ' +'.js-select2');
      select.initSelectWithoutSearch(wrapper + ' ' +'.js_ui-base-select');
      select.initSelectedAll(wrapper + ' ' +'.js_ui-checkbox-selected-all');

      //init tooltip
      $(wrapper + ' ' +'*').tooltip({
        track: true,
      });
      $(wrapper + ' ' +'#menu *[title]').tooltip('disable');
      $(wrapper + ' ' +'[data-toggle="tooltip"]').tooltip("destroy");

      //init text editor
      ui.editor_init(wrapper + ' ' +'.js-ckeditor');

      // Init Date-time piker plugin
      $(wrapper + ' ' +'.js_datetime_picker').each(function () {
        let datatimepicker = new Datatime_picker(this);
        datatimepicker.init();
      });

      //iCheck for checkbox and radio inputs
      ui.iCheckInit();

      let ajax_form = new AjaxForm(wrapper + ' ' + '.js-submit');
      ajax_form.init();
    }

    /**
     * Init all graphics
     */
    initAllGraphics(){
        $('.js_graphic').each(function(){

            let $graphicOptions = $(this).data('options');
            if($graphicOptions == undefined) return;

            let objOptionsGraphic = JSON.parse(JSON.stringify( $graphicOptions));

            let graphic = new Graphic(objOptionsGraphic);
            graphic.init();
        });
    }

    /**
     * Init dropzone
     *
     * to more information go to dropzone init file
     */
    dropzoneInit(){
        let $dropzoneInit = $('.js_dropzone-init');
        if(!$dropzoneInit.length) {
            return;
        }

        // each element init
        $dropzoneInit.each((i, el)=>{
            // get name of class if need, to have ability affect to each class
            let name = $(el).data('class-name');

            if(!name) {
                name = `dropzone_${i}`;
            }

            if(this[name] !== undefined){
                console.error('Error in file main.js on function dropzoneInit, try to init class with name which already exist - ' + name);
                return false;
            }

            this[name] = new DropZone({
                initClass: el,
                btnSubmitImages: '.js_dropzone-submit',
                availableOptionsFromDataAttr : [
                    'maxFilesize',
                    'paramName',
                    'uploadMultiple',
                    'addRemoveLinks',
                    'acceptedFiles',
                ]
            });

            this[name].init();
        });
    }

    //Fine Uploader
    uploaderInit(){
        let $uploader  = $('.js_uploader');
        if(!$uploader.length) {
            return;
        }

        // each element init
        $uploader.each((i, el)=>{
            // get name of class if need, to have ability affect to each class
            let name = $(el).data('class-name');

            if(!name) {
                name = `uploader_${i}`;
            }

            if(this[name] !== undefined){
                console.error('Error in file main.js on function uploaderInit, try to init class with name which already exist - ' + name);
                return false;
            }

            this[name] = new Uploader({
                element: el,
                availableOptionsFromDataAttr : [
                    'itemLimit',
                    'request-endpoint',
                    'deleteFile-endpoint',
                    'deleteFile-enabled',
                    'sizeLimit'
                ]
            });

            this[name].init();
        });

    }


}




// WEBPACK FOOTER //
// ./js/script/main.js